/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    Shopify.theme.jsTabs = {
      init: function($section) {

          $( document ).ready(function() {
            $('.tabs-btn li').click(function(){
              var index = $(this).data('index');
              console.log(index);
              $('.tabs-btn li').removeClass('is-active');
              $(this).addClass('is-active');
              $('.tab-rte div').removeClass('is-visible');
              $('.rte-item.content__'+index).addClass('is-visible');    
            })
        })
      },
      unload: function($section) {
    
      }
    }
    
    /******/ })()
    ;